import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { personAvailabilityChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const PersonAvailabilityChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={personAvailabilityChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default PersonAvailabilityChannel;
